export enum EMessageDirection {
  IN = 'in',
  OUT = 'out',
  SYSTEM = 'system',
}

export enum EMessageChannel {
  SMS = 'sms',
  EMAIL = 'email',
  FACEBOOK_MESSENGER = 'fb_messenger',
}

export function isMessageChannel(channel: string): channel is EMessageChannel {
    return [
        EMessageChannel.SMS,
        EMessageChannel.EMAIL,
        EMessageChannel.FACEBOOK_MESSENGER
    ].includes(channel as EMessageChannel);
}

export type IMessageAttachment = {
  id: number,
  message_uuid: string,
  original_filename: string,
  s3_path: string,
  mimetype: string,
  file_size: number,
  file_hash: string,
  inserted_at: string | Date,
  download_url: string;
}

export enum EMessageSentStatus {
  SENT = 'sent',
  DELIVERED = 'delivered',
  UNDELIVERED = 'undelivered',
}

export enum EMessageSystemMessageType {
    APPLICATION_RECEIVED = 'application_received',
    APPLICATION_REQUESTED = 'application_requested',
    TOUR_CANCELLED = 'tour_cancelled',
    TOUR_CREATED = 'tour_created',
    TOUR_REQUESTED = 'tour_requested',
    TOUR_UPDATED = 'tour_updated',
    INBOUND_CONNECTED_CALL = 'inbound_connected_call',
    OUTBOUND_CONNECTED_CALL = 'outbound_connected_call',
    MISSED_CALL = 'missed_call'
}

export type IMessage = {
  uuid?: string;
  owner: number;
  channel: EMessageChannel;
  contents: string;
  direction: EMessageDirection;
  /**
   * Only set for outgoing SMS messages
   */
  sent_status?: EMessageSentStatus;

  is_sent_by_automation: boolean;
  is_rental_application_request: boolean;

  inserted_at: string | Date;
  system_message_type?: EMessageSystemMessageType;
}

export type ISendMessageResponse = {
    new_message: {
        inserted_at: Date;
        direction: string;
        contents: string;
        is_sent_by_automation: boolean;
    };
}
